<template>
  <div class="card-empty-state" :data-locator="dataLocator">
    <v-card
      class="card-empty-state__card d-flex flex-column align-center justify-center text-center"
      elevation="0"
      :style="{ minHeight: `${minHeight}px` }"
    >
      <app-material-icon
        :name="icon"
        size="xl"
        class="mb-4"
      />

      <h3
        class="mb-2 card-empty-state__title"
        :data-locator="titleDataLocator"
      >
        {{ title }}
      </h3>

      <p
        class="text--small card-empty-state__text"
        :data-locator="textDataLocator"
      >
        {{ text }}
      </p>

      <slot />
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AppCardEmptyState',
  props: {
    icon: {
      type: String,
      default: 'description',
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    minHeight: {
      type: Number,
      default: 220,
    },
    dataLocator: {
      type: String,
      default: 'empty-state',
    },
    titleDataLocator: {
      type: String,
      default: 'empty-state-title',
    },
    textDataLocator: {
      type: String,
      default: 'empty-state-text',
    },
  },
}
</script>

<style scoped lang="scss">
.card-empty-state {
  width: 100%;
}

.card-empty-state__card {
  border: 1px solid rgb(var(--v-theme-grey-100));
  border-radius: 12px !important;
  background: #fff;
}
</style>
